import {Color} from '@benchling/nucleus-ui';
import React from 'react';
import {ReactFlow, MarkerType} from 'reactflow';

import EntityMapControls from 'registry/entity-map/EntityMapControls';
import EntityMapEdge from 'registry/entity-map/EntityMapEdge';
import DefaultBackground from 'ui-library/reactflow/backgrounds/DefaultBackground';
import {useDefaultReactFlowProps} from 'ui-library/reactflow/ReactFlowConstants';

import {DEFAULT_FIT_VIEW_SETTINGS} from './EntityMapConstants';
import {useEntityMapActorRef, useEntityMapSelector} from './EntityMapMachineProvider';
import EntityNode from './EntityNode';

const ENTITY_MAP_NODE_TYPES = {
  entity: EntityNode,
};

const ENTITY_MAP_EDGE_TYPES = {
  entityEdge: EntityMapEdge,
};

/**
 * Renders a view of the entity map for a given entityId
 */
export default function EntityMapView(): JSX.Element {
  const defaultReactFlowProps = useDefaultReactFlowProps();
  const graphNodesById = useEntityMapSelector((s) => s.context.graphNodesById);
  const graphEdgesById = useEntityMapSelector((s) => s.context.graphEdgesById);
  const actorRef = useEntityMapActorRef();

  const graphNodes = Array.from(graphNodesById.values());
  const graphEdges = Array.from(graphEdgesById.values());

  return (
    <ReactFlow
      {...defaultReactFlowProps}
      defaultEdgeOptions={{
        style: {
          color: Color.GRAY_400,
        },
        markerEnd: {
          type: MarkerType.Arrow,
          width: 20,
          height: 20,
          color: Color.GRAY_400,
        },
        labelStyle: {
          color: Color.GRAY_800,
        },
      }}
      nodes={graphNodes}
      edges={graphEdges}
      nodeTypes={ENTITY_MAP_NODE_TYPES}
      edgeTypes={ENTITY_MAP_EDGE_TYPES}
      onlyRenderVisibleElements={true}
      fitView={true}
      fitViewOptions={DEFAULT_FIT_VIEW_SETTINGS}
      minZoom={0.1}
      deleteKeyCode={null} // disable deleting nodes or edges
      selectionKeyCode={null} // disable click drag selection
      nodesDraggable={false}
      onNodesChange={(changes) => {
        actorRef.send({type: 'onNodesChange', changes});
      }}
      onEdgesChange={(changes) => {
        actorRef.send({type: 'onEdgesChange', changes});
      }}
    >
      <DefaultBackground />
      <EntityMapControls />
    </ReactFlow>
  );
}
